import EntityChallengeSwitch from './EntityChallengeSwitch';

export default EntityChallengeSwitch;
